import React from 'react';
import LazyLoad from 'react-lazyload';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

const LazySection = ({ height = 300, offset = -100, children, sitecoreContext, scrollContainer = undefined, overflow = false }) => {
  return (
    <section style={{ padding: '0px' }}>
      {sitecoreContext?.pageEditing ? (
        children
      ) : (
        <LazyLoad overflow={overflow} scrollContainer={scrollContainer} once={true} offset={offset} height={height}>
          {children}
        </LazyLoad>
      )}
    </section>
  );
};

export default withSitecoreContext()(LazySection);
